import { locales } from '@americanexpress/conditional-features';
import { ANYTIME } from './packagesConstants';

const {
  EN_AU,
  EN_CA,
  EN_NZ,
  EN_US,
  FR_CA,
  FR_FR,
  IT_IT,
  SV_SE,
  EN_HK,
  EN_SG,
} = locales;

export const MARKET_CONFIG_OVERRIDES = {
  [EN_AU]: {
    MIN_ADVANCE_AIR_HOTEL_BOOKING: 2,
  },
  [EN_NZ]: {
    MIN_ADVANCE_AIR_HOTEL_BOOKING: 2,
  },
  [EN_CA]: {
    MIN_ADVANCE_AIR_CAR_BOOKING: 1,
    MIN_ADVANCE_AIR_HOTEL_CAR_BOOKING: 1,
    MAX_CHILDREN: 3,
    MAX_INFANTS: 3,
    MAX_COMBINED_CHILDREN_AND_INFANTS: 3,
  },
  [FR_CA]: {
    MIN_ADVANCE_AIR_CAR_BOOKING: 1,
    MIN_ADVANCE_AIR_HOTEL_CAR_BOOKING: 1,
    MAX_CHILDREN: 3,
    MAX_INFANTS: 3,
    MAX_COMBINED_CHILDREN_AND_INFANTS: 3,
  },
  [EN_US]: {
    MIN_ADVANCE_AIR_HOTEL_BOOKING: 0,
    MIN_ADVANCE_AIR_CAR_BOOKING: 0,
    MIN_ADVANCE_AIR_HOTEL_CAR_BOOKING: 0,
    MAX_NIGHTS: 28,
    MAX_ADVANCE_BOOKING: 330,
    MAX_CHILDREN: 6,
    MAX_INFANTS: 6,
    MAX_TRAVELERS_PER_ROOM: 6,
    MAX_ROOMS: 4,
    IS_DRIVERS_AGE: false,
  },
  [FR_FR]: {
    MIN_ADVANCE_AIR_CAR_BOOKING: 1,
    MIN_ADVANCE_AIR_HOTEL_CAR_BOOKING: 1,
  },
  [IT_IT]: {
    MIN_ADVANCE_AIR_CAR_BOOKING: 1,
    MIN_ADVANCE_AIR_HOTEL_CAR_BOOKING: 1,
  },
  [SV_SE]: {
    MIN_ADVANCE_AIR_CAR_BOOKING: 3,
    MIN_ADVANCE_AIR_HOTEL_CAR_BOOKING: 3,
  },
  [EN_HK]: {
    MIN_ADVANCE_AIR_HOTEL_BOOKING: 2,
  },
  [EN_SG]: {
    MIN_ADVANCE_AIR_HOTEL_BOOKING: 2,
  },
};

export const DEFAULT_CONFIG = {
  MIN_NIGHTS: 1,
  MIN_NIGHTS_AIR_CAR: 0,
  MAX_NIGHTS: 331,
  MAX_ADVANCE_BOOKING: 331,
  MAX_TRAVELERS_PER_ROOM: 9,
  MAX_TRAVELERS_COUNT: 27,
  MAX_ROOMS: 3,
  MAX_ADULTS: 6,
  MAX_CHILDREN: 3,
  MAX_INFANTS: 3,
  MIN_ADVANCE_AIR_CAR_BOOKING: 2,
  MIN_ADVANCE_AIR_HOTEL_BOOKING: 1,
  MIN_ADVANCE_AIR_HOTEL_CAR_BOOKING: 2,
  MIN_DRIVERS_AGE: 18,
  MAX_DRIVERS_AGE: 99,
  IS_DRIVERS_AGE: true,
  DEFAULT_TIME: ANYTIME,
};
